import MenuPersonasPsicograficas from "../MenuPersonasPsicograficas";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function InfoPsicografico() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/personas-psicograficas">Personas Psicográficas</a>
                  </li>
                  <li className="breadcrumb-item active">
                    O que são as informações psicográficas da Sales Box?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuPersonasPsicograficas />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                O que são as informações psicográficas da Sales Box?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Personas Psicográficas</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Perfil comportamental
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  As informações psicográficas se aprofundam nas características
                  psicológicas e comportamentais dos clientes. Isso inclui
                  valores, crenças, estilo de vida, interesses, hábitos de
                  compra e motivações. Aqui estão algumas razões para valorizar
                  informações psicográficas:
                </p>
                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Compreensão Profunda do Cliente:
                    </a>{" "}
                    As informações psicográficas permitem uma compreensão mais
                    profunda do que motiva os clientes a agir. Isso é crucial
                    para criar e desenvolver produtos que atendam às suas
                    necessidades emocionais.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Personalização de Conteúdo:
                    </a>{" "}
                    Com base nas informações psicográficas, as empresas podem
                    personalizar conteúdo e experiências de compra para se
                    conectar emocionalmente com os clientes, aumentando a
                    fidelidade à marca.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Maior Retenção de Clientes:
                    </a>{" "}
                    Ao entender as motivações e valores dos clientes, as
                    empresas podem construir relacionamentos mais sólidos e
                    duradouros, o que resulta em maior retenção de clientes.
                  </li>
                </ul>

                <figure>
                  <img src="img/personas.png" alt="excel" />
                </figure>

                <figcaption>Personas</figcaption>

                <p>
                  Essas informações são ferramentas poderosas para ajudar as
                  empresas conhecerem melhor seus clientes, pois esses insights
                  não apenas impulsionam estratégias de marketing mais eficazes,
                  mas também melhoram a satisfação do cliente, promovem a
                  fidelidade à marca e, em última análise, contribuem para o
                  sucesso a longo prazo da empresa.
                </p>
                <p>
                  As variáveis psicográficas da <a> </a>
                  <a href="https://salesbox.com.br/" target="blank">
                    <a className="nav-item">Sales Box</a>
                  </a>
                  <a> </a>foram construídas a partir de pesquisas de mercado
                  realizadas nos últimos anos, combinando diferentes técnicas
                  capazes de capturar propensões de comportamentos para
                  diferentes tipos de ofertas, além de investigar opiniões e
                  atitudes nas mais de 250 frases que auxiliam na elaboração do
                  perfil psicográfico da população brasileira.
                </p>

                <p>
                  Combinar a renda presumida individual juntamente às variáveis
                  psicográficas, ambas oferecidas pela <a> </a>
                  <a href="https://salesbox.com.br/" target="blank">
                    <a className="nav-item">Sales Box</a>
                  </a>
                  , formam uma poderosa ferramenta de segmentação e análise de
                  comportamento financeiro e consumo individual.
                </p>

                <p>
                  A partir destes critérios psicográficos desenvolvemos nove
                  personas: Racional, Tradicional, Conservador, Imediatista,
                  Antenado, Sofisticado, Compassível e Inovadores.
                </p>

                <figure>
                  <img src="img/bigfive.png" alt="excel" />
                </figure>

                <figcaption>Exemplo de perfil: Persona Imediatista</figcaption>

                <p>
                  Somos capazes de identificar as personas da sua base de dados
                  e fornecer informações detalhadas como: informações
                  demográficas, perfil financeiro, personalidade, principais
                  características de consumo e muito mais, tudo de forma
                  individualizada para cada uma das nove personas desenvolvidas
                  pela{" "}
                  <a href="https://site.salesbox.com.br/" target="blank">
                    {" "}
                    Sales Box
                  </a>
                  .
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
